<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist
			@help="help"
			@add="add"
			@search="search"
			@reflash="reflash"
			@del="delall"
			ref="SetBtn"
		></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<el-table
			id="xpane-0"
			:data="datajson"
			v-loading="loading"
			:highlight-current-row="false"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			@cell-dblclick="editInfo"
			tab-click="selectInfo(0)"
			header-row-class-name="headerclass"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			:header-cell-style="$limits.headerClass"
			ref="singleTable"
		>
			<el-table-column  type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_ENGTYPE_CODE" :label="$t('getapi[3337]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_ENGTYPE_NAME" :label="$t('getapi[3338]')" width="100"></el-table-column>
			<el-table-column prop="nocheck_batch_qty" :label="$t('getapi[7985]')" align="right" width="80">
				<template slot-scope="scope">
					{{scope.row.nocheck_batch_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column prop="normal_batch_qty" :label="$t('getapi[7986]')" align="right" width="80">
				<template slot-scope="scope">
					{{scope.row.normal_batch_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column prop="strict_batch_qty" :label="$t('getapi[7987]')" align="right" width="80">
				<template slot-scope="scope">
					{{scope.row.strict_batch_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="start_time" :label="$t('getapi[7988]')" width="100"></el-table-column>
			<el-table-column prop="report_need_one" :label="$t('getapi[13181]')" width="100">
                <template scope="scope">
                    <span>{{ scope.row.report_need_one}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="report_need_two" :label="$t('getapi[13182]')" width="100">
                <template scope="scope">
                    <span>{{ scope.row.report_need_two}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="report_need_three" :label="$t('getapi[13183]')" width="100">
                <template scope="scope">
                    <span>{{ scope.row.report_need_three}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="report_person"  width="100" :label="$t('getapi[13245]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="report_person_two" width="100" :label="$t('getapi[13244]')"></el-table-column>
			
			<el-table-column show-overflow-tooltip prop="REMARK" :label="$t('getapi[143]')" width="100"></el-table-column>
			<el-table-column :label="$t('getapi[6048]')" width="80">
				<template slot-scope="scope">
					<el-button :disabled="!btn.edit" @click.native.prevent="edit(scope)" type="text" size="small">{{ $t('getapi[34]') }}</el-button>
					<el-popconfirm
						:confirmButtonText="$t('getapi[6109]')"
						:cancelButtonText="$t('getapi[6]')"
						icon="el-icon-info"
						iconColor="red"
						:title="$t('getapi[637]')"
						@onConfirm="del(scope)"
					>
						<el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<!--<el-col :span="12">
				<el-pagination
					style="margin-top: 1em"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[50, 100, 200, 300, 400]"
					:page-size="50"
					background
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="12">-->
				<div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			<!--</el-col>-->
		</el-row>
		<!-- 分页 -->
		<!-- 搜索弹框 -->
		<el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[3653]')" width="30%" :close-on-click-modal="false">
			<el-tabs type="border-card">
				<el-tab-pane :label="$t('getapi[2020]')">
					<el-table :data="queryData" border height="400" size="mini" style="width: 100%;">
						<el-table-column show-overflow-tooltip prop="Field_Show_Name" :label="$t('getapi[2021]')" width="150"></el-table-column>
						<el-table-column :label="$t('getapi[2022]')">
							<template slot-scope="scope">
								<input type="text" v-model="scope.row.query_Condition" style="border:none" />
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane :label="$t('getapi[2028]')"><div style="min-height: 400px; line-height: 30px;" v-html="hleptext"></div></el-tab-pane>
			</el-tabs>

			<span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="intidata">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
		<!-- 搜索弹框 -->
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[34]')" width="30%" :close-on-click-modal="false">
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[3337]')}}</td>
					<td><el-input v-model="formInline._part_engtype_code" type="text" size="mini" ></el-input></td>
					<td>{{$t('getapi[3338]')}}</td>
					<td><el-input v-model="formInline._part_engtype_name" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
                    <td>{{$t('getapi[7985]')}}</td>
					<td><el-input v-model="formInline._nocheck_batch_qty" type="number" autocomplete="off" title="" size="mini" @mousewheel.native.prevent></el-input></td>
					<td>{{$t('getapi[7986]')}}</td>
					<td><el-input v-model="formInline._normal_batch_qty" type="number" autocomplete="off" title="" size="mini" @mousewheel.native.prevent></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[7987]')}}</td>
					<td><el-input v-model="formInline._strict_batch_qty" type="number" autocomplete="off" title="" size="mini" @mousewheel.native.prevent></el-input></td>
                    <td>{{$t('getapi[7988]')}}</td>
					<td><el-input v-model="formInline._start_time"  size="mini" ></el-input></td>
				</tr>
				<tr>
                    <td>{{$t('getapi[13181]')}}</td>
					<td><el-input v-model="formInline._report_need_one" type="text" size="mini"></el-input></td>
                    <td>{{$t('getapi[13182]')}}</td>
					<td><el-input v-model="formInline._report_need_two" type="text" size="mini"></el-input></td>
                </tr>    
                <tr>
					<td>{{$t('getapi[13183]')}}</td>
					<td><el-input v-model="formInline._report_need_three" type="text" size="mini"></el-input></td>
                    <td>{{$t('getapi[13245]')}}</td>
					<td>
						<routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
							<el-input
									v-model="formInline._report_person"
							>
								<i class="el-icon-edit el-input__icon" slot="suffix" @click="seluserinfo(2)"></i>
							</el-input>
						</routejump>
						<!-- <el-input v-model="formInline._report_person" type="text" size="mini"></el-input> -->
					</td>
                </tr> 
				<tr>
					<td>{{$t('getapi[13244]')}}</td>

					<td>
						<routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
							<el-input
									v-model="formInline._report_person_two"
							>
								<i class="el-icon-edit el-input__icon" slot="suffix" @click="seluserinfo(1)"></i>
							</el-input>
						</routejump>
							<!-- <el-input v-model="formInline._report_person_two" type="text" size="mini"></el-input> -->
					</td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>

			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="editvisi = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="sava" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
		<!-- 编辑弹框 -->

		<selector
                :isVisible="uservisible"
                :isBatch="false"
                :selectType="0"
                :isSplitPage="true"
                :postUrl="'/Basic/Popup/GetQualityUsersPopuDataList'"
                @callback="getuserinfo"
                ref="userinfo"
        ></selector>
		
	</div>
</template>

<script>
import Common from '@/components/Common';
export default {
	name: 'itemprotype',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			formInline: {
				_exclusively_id: 0,
				_part_engtype_code: '',
				_part_engtype_name: '',
                _nocheck_batch_qty:'',
                _normal_batch_qty:'',
                _strict_batch_qty:'',
                _start_time:'',
				_remark: '',
				_report_need_one:'',
				_report_need_two:'',
				_report_need_three:'',
				_report_person:'',
				_report_person_two:'',
			},
			ids: '',
			showloading: '',
			isVisible: false,
			editvisi: false,
			DbTbNames: '', //表名
			datajson: [],
			PageIndex: 1,
			PageSize: 50,
			SelectIndex: 1,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			dataSetDetail: {}, // 编辑页面数据详情
			queryData: [], // 查询数组
			selectIDData: '', // 选择的数据的ID集合
			tracetype: 0, //跟踪类别
			url: '', // 零件图路径
			isEdit: true ,// 是否新增
			btn: {
				del: false,
				edit: false
			},
            scrollTop:0,
			uservisible:false,
			persontype:1,//1:国外负责人、2:国内负责人
		};
	},
	create() {},
	beforeMount() {
		console.log('beforeMount');
		//this.getqwlist();
	},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted() {
		console.log('mounted');
		let that = this;
		that.intidata();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1088]"),this.$t("getapi[11]"));
        },
		//按钮操作权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			//只读权
			if (that.$limits.ReadOnlyRights('plv2', 26, 1)) {
				that.$refs.SetBtn.SetButtonEnable('search,refresh');
			}
			//操作权
			let ilimits = that.$limits.UnOperationAuthority('plv2', 26, 1);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (ilimits) {
				case 2:
					that.btn.edit = true;
					that.btn.del = false;
					that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh');
					break;
				case 3:
					that.btn.edit = true;
					that.btn.del = true;
					that.$refs.SetBtn.SetButtonEnable('create,search,save,del,refresh');
					break;
				default:
					that.$refs.SetBtn.SetButtonEnable('');
					break;
			}
		},
		seluserinfo(type) {
			let that = this
			that.persontype = type
			this.uservisible = true;
			this.$refs.userinfo.clearInput(this.uservisible);
		},
		//负责人
		getuserinfo(data) {
			let that = this; 
			if(that.persontype==1){
				// 国外
				that.formInline._report_person_two = data.name+'('+data.userid+')';
			}
			else if(that.persontype==2){
				// 国内
				that.formInline._report_person = data.name+'('+data.userid+')';
			}
		},
		beforeRoutJump(val,callback){
			let that = this
			if(that.oldFormInline != JSON.stringify(that.formInline)){
				this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
					confirmButtonText: that.$t('getapi[1146]'),
					cancelButtonText: that.$t('getapi[2054]'),
					type: 'warning'
				})
					.then(() => {
						that.isVisible = false
						callback(true)
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: that.$t('getapi[6096]')
						});
					});
			} else {
				that.isVisible = false
				callback(true)
			}
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
			this.intidata();
			this.authority();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
			this.intidata();
			this.authority();
		},
		//编辑
		editInfo(row) {
			let that = this;
		},
		// 获取数据
		intidata() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			that.$http.urlpost('Basic/Items/GetPartTypeList', '', function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.datajson = res.DataContent;
					that.DbTbNames = res.DbTbNames;
				}
				that.loading = false;
				that.authority();
			});
		},
		// 保存数据
		sava() {
			let that = this;
			that.loading = true;
			let parm = new Array();
			parm.push(that.formInline);
			console.log(JSON.stringify(parm));
			that.$http.urlpost('Basic/Items/SavePartType', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[284]'));
                    that.editvisi = false;
					that.intidata();
				}
				that.loading = false;
			});
		},
		// 获取查询条件
		getqwlist() {
			let that = this;
			that.$http.urlpost('Basic/Items/WorkCenterQWList', {}, function(res) {
				that.queryData = res.DataContent;
			});
		},
		// 编辑
		edit(jsd) {
			console.log(jsd);
			this.editvisi = true;
			this.formInline = {
				_exclusively_id: jsd.row.Exclusively_Id,
				_part_engtype_code: jsd.row.part_ENGTYPE_CODE,
				_part_engtype_name: jsd.row.part_ENGTYPE_NAME,
                _nocheck_batch_qty:jsd.row.nocheck_batch_qty,
                _normal_batch_qty:jsd.row.normal_batch_qty,
                _strict_batch_qty:jsd.row.strict_batch_qty,
                _start_time:jsd.row.start_time,
				_remark: jsd.row.REMARK,
				_report_need_one: jsd.row.report_need_one,
				_report_need_two: jsd.row.report_need_two,
				_report_need_three: jsd.row.report_need_three,
				_report_person: jsd.row.report_person,
				_report_person_two: jsd.row.report_person_two,
			};
			console.log(this.formInline);
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Exclusively_Id + ',';
			}
			console.log(that.selectIDData);
		},
		// 删除
		delf() {
			let that = this;
			let parm = {
				ids: that.ids
			};
			console.log(parm);
			that.$http.urlpost('Basic/Items/DeletePartTypeByID', parm, function(res) {
				that.intidata();
				that.$message.success(that.$t('getapi[659]'));
			});
		},
		// 删除
		del(jsd) {
			this.ids = jsd.row.Exclusively_Id + ',';
			this.delf();
		},
		//批量删除
		delall() {
			let that = this;
			that.ids = this.selectIDData;
			that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					that.delf();
				})
				.catch(() => {});
		},
		// 新增
		add() {
            this.formInline = {
                _exclusively_id: 0,
                _part_engtype_code: '',
                _part_engtype_name: '',
                _nocheck_batch_qty:'',
                _normal_batch_qty:'',
                _strict_batch_qty:'',
                _start_time:'',
                _remark: '',
				_report_need_one:'',
				_report_need_two:'',
				_report_need_three:'',
				_report_person:'',
				_report_person_two:'',
            }
			this.editvisi = true;
		},
		// 查询
		search() {
			this.isVisible = true;
		},
		// 刷新
		reflash() {
			this.intidata();
			this.authority();
		}
		//导出·
		// exp() {
		// 	let that = this;
		// 	that.showloading = that.openLoading();
		// 	let pm = {
		// 		query_Condition: '',
		// 		query_field_type: '',
		// 		query_field_name: ''
		// 	};
		// 	let parm = {
		// 		PageIndex: that.PageIndex,
		// 		PageSize: that.PageSize,
		// 		SelectIndex: that.SelectIndex,
		// 		Ids: that.selectIDData,
		// 		Param: []
		// 	};
		// 	that.queryData.forEach(item => {
		// 		if(item.query_Condition==''||item.query_Condition.length>0) {
		// 			pm = {
		// 				query_Condition: item.query_Condition,
		// 				query_field_type: item.Query_Field_Type,
		// 				query_field_name: item.Query_Field_Name
		// 			};
		// 			parm.Param.push(pm);
		// 		}
		// 	});
		// 	console.log(parm);
		// 	that.$http.urlpost('Basic/Items/WorkCenter_ExportToExecl', parm, function(res) {
		// 		if (res.Success == 1) {
		// 			let hrefurl = Common.Url + res.DataContent.URL;
		// 			window.open(hrefurl);
		// 		} else {
		// 			that.$message.error(res.Msg);
		// 		}
		// 		that.showloading.close();
		// 	});
		// }
	}
};
</script>

<style lang="scss" scoped>

table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
